import throttle from 'javascripts/utils/throttle';
import NavigationOverlay from '../navigation/navigation.overlay';

export default class HeaderSticky {
  constructor($panel) {
    this.$header = document.querySelector('.header');
    this.$navigation = document.querySelector('.navigation');
    this.$panel = $panel;
    this.navigationWasFlyout = false;

    // Change point
    if (this.$header.classList.contains('header--login')) {
      this.change = 105;
    } else {
      this.change = 35;
    }

    // Binded events
    this.bindedScroll = throttle(this.scroll.bind(this));

    // Add events
    document.addEventListener('scroll', this.bindedScroll, { passive: true });

    // Check for initial scrollposition
    this.scroll();
  }

  deconstructor() {
    // Remove events
    document.removeEventListener('scroll', this.bindedScroll);
  }

  scroll() {
    const scroll = window.scrollY || window.pageYOffset;
    const navigationClasses = this.$navigation.classList;

    if (scroll >= this.change) {
      this.$header.classList.add('header--sticky');

      if (navigationClasses.contains('navigation--flyout')) {
        this.navigationWasFlyout = true;
        this.$navigation.classList.remove('navigation--flyout');

        this.$navigation.classList.add('navigation--overlay');

        this.navigationOverlay = new NavigationOverlay(this.$navigation);
        this.navigationOverlay.init();
      }
    } else if (scroll < this.change) {
      this.$header.classList.remove('header--sticky');

      if (this.navigationWasFlyout) {
        this.navigationOverlay.deinit();
        this.$navigation.classList.add('navigation--flyout');
      }
    }
  }
}
